import { List, Datagrid, TextField, EditButton, FunctionField } from 'react-admin';
import { Chip } from '@mui/material';

const FullNameField = ({ record }) => {
    if (!record) return null;
    return <span>{`${record.firstName || ''} ${record.lastName || ''}`.trim() || '—'}</span>;
};

const RoleChip = ({ record }) => {
    if (!record) return null;
    const isAdmin = record.role === 'Admin';
    return <Chip label={record.role} size="small" sx={{
        bgcolor: isAdmin ? '#1A1A1A' : '#f5f5f5',
        color: isAdmin ? '#fff' : '#666',
        fontWeight: 600,
    }} />;
};

const UserList = () => (
    <List perPage={25}>
        <Datagrid rowClick="edit">
            <FullNameField source="firstName" label="Имя" />
            <TextField source="email" label="Email" />
            <TextField source="phone" label="Телефон" />
            <RoleChip source="role" label="Роль" />
        </Datagrid>
    </List>
);

export default UserList;
